module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_4.b426c866.png";